// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { FulfillmentMethod } from "@insite/client-framework/Services/SessionService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import changePickUpWarehouse from "@insite/client-framework/Store/Components/AddressDrawer/Handlers/ChangePickUpWarehouse";
import translate from "@insite/client-framework/Translate";
import { WarehouseModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import FindLocationModal, { FindLocationModalStyles } from "@insite/content-library/Components/FindLocationModal";
/* Starter Custom Code
import WarehouseAddressInfoDisplay, {
    WarehouseAddressInfoDisplayStyles,
} from "@insite/content-library/Components/WarehouseAddressInfoDisplay";
*/
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import WarehouseAddressInfoDisplay, {
    WarehouseAddressInfoDisplayStyles,
} from "@store/Overrides/Components/WarehouseAddressInfoDisplay";
import { addressProps } from "@store/Themes/common/props/address";
/* Starter Custom Code - End */

/* Store Custom Code - Start */
import getIsB2BBillTo from "@store/Framework/Common/Utilities/getIsB2BBillTo";
/* Store Custom Code - End */

interface OwnProps extends WidgetProps {}

const mapStateToProps = (state: ApplicationState) => ({
    fulfillmentMethod: state.components.addressDrawer.fulfillmentMethod,
    pickUpWarehouse: state.components.addressDrawer.pickUpWarehouse,
    /* Store Custom Code - Start */
    selectedBillTo: state.components.addressDrawer.selectedBillTo,
    /* Store Custom Code - End */
});

const mapDispatchToProps = {
    changePickUpWarehouse,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface AddressDrawerPickUpLocationSelectorStyles {
    wrapper?: InjectableCss;
    headerText?: TypographyPresentationProps;
    changeLink?: LinkPresentationProps;
    warehouseAddress?: WarehouseAddressInfoDisplayStyles;
    findLocationModal?: FindLocationModalStyles;
}

export const addressDrawerPickUpLocationSelectorStyles: AddressDrawerPickUpLocationSelectorStyles = {
    wrapper: {
        css: css`
            font-size: ${x => x.theme.design.typography.size.small};
        `,
    },
    headerText: addressProps.label,
    changeLink: addressProps.link,
    warehouseAddress: {
        wrapper: {
            css: css`
                font-size: ${x => x.theme.design.typography.size.smaller};
            `,
        },
        warehouseNameText: addressProps.name,
    },
};

const styles = addressDrawerPickUpLocationSelectorStyles;

const AddressDrawerPickUpLocationSelector = ({
    fulfillmentMethod,
    pickUpWarehouse,
    changePickUpWarehouse,
    // Store Custom Code
    selectedBillTo,
}: Props) => {
    /* Store Custom Code - Start */
    if (!getIsB2BBillTo(selectedBillTo)) {
        return null;
    }
    /* Store Custom Code - End */

    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const handleChangeLocationClick = () => {
        setIsModalOpen(true);
    };
    const handleModalClose = () => setIsModalOpen(false);
    const handleWarehouseSelected = (warehouse: WarehouseModel) => {
        changePickUpWarehouse({ warehouse });
        setIsModalOpen(false);
    };

    return (
        <>
            <StyledWrapper
                id="addressDrawerPickUpLocationSelector"
                role="region"
                aria-live="polite"
                data-test-selector="changeCustomer_pickUpLocation"
                {...styles.wrapper}
            >
                {fulfillmentMethod === FulfillmentMethod.PickUp ? (
                    <>
                        <Typography {...styles.headerText}>
                            {translate("Pick Up Location") /* Starter Custom Code */}
                        </Typography>
                        {/* Starter Custom Code - Link moved down */}
                        {pickUpWarehouse && (
                            <WarehouseAddressInfoDisplay
                                warehouse={pickUpWarehouse}
                                extendedStyles={styles.warehouseAddress}
                            />
                        )}
                        <Link
                            onClick={handleChangeLocationClick}
                            data-test-selector="changeCustomer_pickUpLocation_findLocation"
                            {...styles.changeLink}
                        >
                            {/* Starter Custom Code - Start */}
                            {translate("Change")}
                            <VisuallyHidden>{translate("Pick Up Location")}</VisuallyHidden>
                            {/* Starter Custom Code - End */}
                        </Link>
                    </>
                ) : (
                    <></>
                )}
            </StyledWrapper>
            <FindLocationModal
                modalIsOpen={isModalOpen}
                onWarehouseSelected={handleWarehouseSelected}
                onModalClose={handleModalClose}
                extendedStyles={styles.findLocationModal}
            />
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(AddressDrawerPickUpLocationSelector),
    definition: {
        group: "Header",
    },
};

export default widgetModule;
